<template>
  <div>
    <loader v-if='loadingSpritesheetImage' class="w-full h-24"/>
    <!--<div v-if='spritesheetData.meta.image' class="p-2 grid grid-cols-4 md:grid-cols-8 gap-2">-->
    <div v-if='spritesheetData.meta.image' class="instant-sprite-from-spritesheet-top" :class='typeClass'>
      <slot name='before' />
      <instant-sprite-from-spritesheet v-for='(image,i) in images' 
                                       :image='image'
                                       :is-selected='image.name === selectedImage.name'
                                       :key='image.url + "-" + i'
                                       :in-viewport='inViewport'
                                       @select='onSelectImage'

                                       />
    </div>
  </div>
</template>
<script>
import InstantSpriteFromSpritesheet from '@ui/atoms/InstantSpriteFromSpritesheet.vue';
import { toPairs } from 'lodash';
export default {
  inject: ['api'],
  props:{
    spritesheet:{
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      spritesheetData: {
        frames:{},
        meta:{}
      },
      selectedImage:{},
      inViewport: false,
      loadingSpritesheetImage:true
    }
  },
  components:{
    InstantSpriteFromSpritesheet
  },
  methods:{
    onSelectImage(image) {
      this.selectedImage = image;
      this.$emit('select', {
        image,
        spritesheet:this.spritesheet
      })
    },
    deselect() {
      this.selectedImage = {};
    }
  },
  async mounted() {
    const url = this.api.makeSpritesheetUrlEditor(this.spritesheet);
    const response = await fetch(url);
    this.spritesheetData = await response.json();

    if ("IntersectionObserver" in window) {
      let options = {
        root: this.$el,
        rootMargin: '0px',
        threshold: 1.0
      }

      this.observer = new IntersectionObserver( (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.inViewport = true;
          this.observer.unobserve(this.$el);
          this.observer = null;
        }
      });
      this.observer.observe(this.$el);
    } else {
      this.inViewport = true;
    }


  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.$el);
    }
  },
  watch:{
    image: {
      immediate:true,
      handler(nv) {
        if (nv && nv.indexOf('placeholder.png') === -1) {
          this.loadingSpritesheetImage = true;
          const img = document.createElement('img');
          img.src = this.image;
          img.onload = () => {
            console.log('loaded image!!!', this.image);
            this.loadingSpritesheetImage = false;
          }
          img.onerror = () => {
            this.loadingSpritesheetImage = false;
          }
        }
      }
    }
  },
  computed:{
    typeClass() {
      if (this.type === 'small') {
        return 'instant-sprite-from-spritesheet-small'
      } else {
        return 'instant-sprite-from-spritesheet-big'
      }
    },
    image() {
      return this.api.makeSpritesheetUrlEditor(this.spritesheetData.meta.image);
    },
    images() {
      const url = this.image;
      return toPairs(this.spritesheetData.frames)
        .map( ([name, tilespec]) => {
          return {
            name,
            tilespec,
            url
          }
        });
    }
  }
}
</script>
<style>
.instant-choose-pack-horizontal .instant-sprite-from-spritesheet-top {
  @apply flex flex-row;
}
.instant-choose-pack-vertical .instant-sprite-from-spritesheet-top {
  @apply p-2 grid grid-cols-3 gap-1;
}

.instant-choose-pack-horizontal .instant-sprite-from-spritesheet-top button {
  @apply w-20 h-12;
}
.instant-choose-pack-vertical .instant-sprite-from-spritesheet-top button {
  @apply h-20;
}



.instant-choose-pack-vertical .instant-sprite-from-spritesheet-small.instant-sprite-from-spritesheet-top {
  @apply p-2 grid grid-cols-3 gap-1;
}

.instant-choose-pack-vertical .instant-sprite-from-spritesheet-small.instant-sprite-from-spritesheet-top button {
  @apply h-32;
}

.instant-choose-pack-vertical .instant-sprite-from-spritesheet-big.instant-sprite-from-spritesheet-top {
  @apply p-2 grid grid-cols-1 gap-1;
}

.instant-choose-pack-vertical .instant-sprite-from-spritesheet-big.instant-sprite-from-spritesheet-top button {
  @apply h-48 w-full;
}


@media (min-width: 768px) {

  .instant-choose-pack-vertical .instant-sprite-from-spritesheet-small.instant-sprite-from-spritesheet-top {
    @apply p-2 grid grid-cols-6 gap-1;
  }

  .instant-choose-pack-vertical .instant-sprite-from-spritesheet-small.instant-sprite-from-spritesheet-top button {
    @apply h-32;
  }

  .instant-choose-pack-vertical .instant-sprite-from-spritesheet-big.instant-sprite-from-spritesheet-top {
    @apply p-2 grid grid-cols-3 gap-1;
  }

  .instant-choose-pack-vertical .instant-sprite-from-spritesheet-big.instant-sprite-from-spritesheet-top button {
    @apply h-64;
  }

}

</style>
